import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import i18n from '@/locales'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/iconfont/iconfont.css'
import './assets/css/index.css'

Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.filter('moneyFormat', function (data) {
  if (parseFloat(data).toString() === 'NaN') {
    data = 0.00
  }
  return data.toFixed(2)
})
new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App)
}).$mount('#app')
